import { ValidatedMultiStringValueInputProps } from './types';
import { FIELD_TO_MULTI_INPUT_MAP, FIELD_TYPE_TO_MULTI_INPUT_MAP } from './constants';

export const MultiValueInput = (props: ValidatedMultiStringValueInputProps) => {
  const InputForField = FIELD_TO_MULTI_INPUT_MAP[props.field];
  const InputForFieldType = FIELD_TYPE_TO_MULTI_INPUT_MAP[props.fieldType];
  const Input = InputForField ?? InputForFieldType;
  return Input ? <Input {...props} /> : <></>;
};
